import { BotSpeedControl } from './BotSpeedControl';
import { useGameStore } from '../../store/gameStore';

export function SettingsDrawer() {
  const settingsOpen = useGameStore((s) => s.settingsOpen);
  const setSettingsOpen = useGameStore((s) => s.setSettingsOpen);

  if (!settingsOpen) return null;

  return (
    <div
      className="pointer-events-auto fixed inset-0 z-20 flex flex-col justify-end bg-black/50"
      role="presentation"
      onClick={() => setSettingsOpen(false)}
    >
      <div
        className="overlay-panel mx-4 mb-4 max-h-[70vh] overflow-y-auto rounded-2xl p-4"
        role="dialog"
        aria-label="설정"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-sm font-semibold text-amber-100">설정</h2>
          <button
            type="button"
            className="overlay-button-ghost min-h-[44px] px-3 py-2"
            onClick={() => setSettingsOpen(false)}
          >
            닫기
          </button>
        </div>
        <BotSpeedControl />
      </div>
    </div>
  );
}
